import './App.css';
import "./style/dark.scss";
import { useContext, useState, Suspense } from "react";
import { DarkModeContext } from "./context/darkModeContext";
import { AuthContext } from "./context/AuthContext";
import i18n from './i18n';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Login from './components/main/Login';
import Register from './components/main/Register';
import LostPassword from './components/main/LostPassword';
import Home from './components/main/Home';
import About from './components/main/About';
import Services from './components/main/Services';
import Contact from './components/main/Contact';
import Footer from './components/main/Footer';
import Blog from './components/blog/Blog';
import News from './components/blog/News';
import Dashboard from './components/main/Dashboard';
import Step0 from './components/main/Step0';
import Step1 from './components/main/Step1';
import Step2 from './components/main/Step2';
import Step3 from './components/main/Step3';
import Step4 from './components/main/Step4';
import Step5 from './components/main/Step5';
import Step6 from './components/main/Step6';
import Step7 from './components/main/Step7';
import Step8 from './components/main/Step8';
import Step9 from './components/main/Step9';
import Logout from './components/main/Logout';
import Admin from './components/admin/home/Home';
import CandidatesList from './components/admin/list/CandidatesList';
import AdminList from './components/admin/list/AdminList';
import ExamList from './components/admin/list/ExamList';
import NewAdmin
 from './components/admin/new/NewAdmin';
 import NewExam
  from './components/admin/new/NewExam';
import Single from './components/admin/single/Single';
import Examinator from './components/admin/single/Examinator';
import Posts from './components/admin/posts/posts';
import NewPost from './components/admin/posts/New';
import Post from './components/admin/posts/post';
import Loading from './components/loading';
import LocaleContext from './LocaleContext';
import Report from './components/main/Report';

function App() {

  const { darkMode } = useContext(DarkModeContext);

  const {currentUser} = useContext(AuthContext)

  const [locale, setLocale] = useState(i18n.language);

  i18n.on('languageChanged', (lng) => setLocale(i18n.language));

  const RequireAuth = ({ children }) => {
    return currentUser ? children : <Navigate to="/login" />;
  };


  return (
    <div>
      <LocaleContext.Provider value={{locale, setLocale}}>
        <Suspense fallback={<Loading />}>
          <BrowserRouter>
            <Routes>
                <Route path="/">
                  <Route  path="login" element={<Login />} />
                  <Route
                      index
                      element={<Home />}
                    />
                  {/* <Route path="contact" element={<Contact />}/> */}
                  <Route  path="register" element={<Register />}/>
                  <Route path="retrievepassword" element={<LostPassword/>}/>
                  <Route
                    path="dashboard"
                    element={
                      <RequireAuth>
                        <Dashboard />
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="step0"
                    element={
                      <RequireAuth>
                        <Step0 />
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="step1"
                    element={
                      <RequireAuth>
                        <Step1 />
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="step2"
                    element={
                      <RequireAuth>
                        <Step2 />
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="step3"
                    element={
                      <RequireAuth>
                        <Step3 />
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="step4"
                    element={
                      <RequireAuth>
                        <Step4 />
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="step5"
                    element={
                      <RequireAuth>
                        <Step5 />
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="step6"
                    element={
                      <RequireAuth>
                        <Step6 />
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="step7"
                    element={
                      <RequireAuth>
                        <Step7 />
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="step8"
                    element={
                      <RequireAuth>
                        <Step8 />
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="step9"
                    element={
                      <RequireAuth>
                        <Step9 />
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="logout"
                    element={
                      <RequireAuth>
                        <Logout />
                      </RequireAuth>
                    }
                  />
                  <Route path="news">
                    <Route
                      index
                      element={<News />}
                    />
                    <Route
                      path=":id"
                      element={<Blog />}
                    />
                    <Route
                      path="new"
                      element={
                        <RequireAuth>
                          <Blog />
                        </RequireAuth>
                      }
                    />
                  </Route>
                  <Route path="admin">
                    <Route
                      index
                      element={
                        <RequireAuth>
                          <Admin />
                        </RequireAuth>
                      }
                    />
                    <Route path="candidats">
                      <Route
                        index
                        element={
                            <CandidatesList />
                        }
                      />
                      <Route
                          path=":id"
                          element={
                            <RequireAuth>
                              <Single />
                            </RequireAuth>
                          }
                        />
                    </Route>
                    <Route path="report">
                      <Route
                        index
                        element={
                            <Report />
                        }
                      />
                    </Route>
                    <Route path="examinators">
                      <Route
                        index
                        element={
                          <RequireAuth>
                          <ExamList />
                        </RequireAuth>
                        }
                      />
                      <Route
                          path="new"
                          element={
                            <RequireAuth>
                              <NewExam />
                            </RequireAuth>
                          }
                        />
                      <Route
                        path=":id"
                        element={
                          <RequireAuth>
                            <Examinator />
                          </RequireAuth>
                        }
                      />
                    </Route>
                    <Route path="administrators">
                      <Route
                        index
                        element={
                          <RequireAuth>
                          <AdminList />
                        </RequireAuth>
                        }
                      />
                      <Route
                          path="new"
                          element={
                            <RequireAuth>
                              <NewAdmin />
                            </RequireAuth>
                          }
                        />
                      <Route
                        path=":id"
                        element={
                          <RequireAuth>
                            <Post />
                          </RequireAuth>
                        }
                      />
                    </Route>
                    <Route path="posts">
                      <Route
                        index
                        element={
                          <RequireAuth>
                          <Posts />
                        </RequireAuth>
                        }
                      />
                      <Route
                          path="new"
                          element={
                            <RequireAuth>
                              <NewPost />
                            </RequireAuth>
                          }
                        />
                      <Route
                        path=":id"
                        element={
                          <RequireAuth>
                            <Post />
                          </RequireAuth>
                        }
                      />
                    </Route>
                  </Route>
                </Route>
            </Routes>
          </BrowserRouter>
        </Suspense>
      </LocaleContext.Provider>
    </div>
  );
}

export default App;
